import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Button, FooterActionBar } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';
import { COMMENT_MINIMUM_LENGTH } from '../constant';
import { BULK_ACTION_CONSULT } from '../mockData';

function BulkActionConsultFooter({
  handleConsult,
  bulkActionConsult,
  handleCloseBulkActionConsult,
}) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);

  const submitBtnKind =
    bulkActionConsult?.isSubmitting ||
    (bulkActionConsult?.comment?.replace(/^\s+|\s+$/gm, '')?.length >
      COMMENT_MINIMUM_LENGTH &&
      !/<|>/.test(bulkActionConsult?.comment) &&
      bulkActionConsult?.consultWith?.length > 0 &&
      bulkActionConsult?.hasAgreed)
      ? 'filled'
      : 'outlined';

  return (
    <FooterActionBar size='large'>
      <div />
      <div className='BulkActionConsultFooter-footerButtonWrap'>
        <Button
          type='button'
          kind='ghost'
          size='medium'
          isDisabled={bulkActionConsult?.isSubmitting}
          onClick={handleCloseBulkActionConsult}>
          {messages['CancelLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('CancelLabel'))}
        </Button>
        <Button
          className='BulkActionConsultFooter-submitButton'
          type='button'
          kind={submitBtnKind}
          size='medium'
          onClick={() =>
            handleConsult(
              bulkActionConsult?.reassignAssociated,
              bulkActionConsult?.consultWith,
              bulkActionConsult?.comment,
              bulkActionConsult?.consultWithName
            )
          }
          isDisabled={bulkActionConsult?.isSubmitting}
          isLoading={bulkActionConsult?.isSubmitting}
          loaderText={
            messages['SubmitLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('SubmitLabel'))
          }>
          {messages['SubmitLabel.ATTESTATIONS'] ||
            localize(intl, getMessageKey('SubmitLabel'))}
        </Button>
      </div>
    </FooterActionBar>
  );
}

BulkActionConsultFooter.propTypes = {
  handleConsult: PropTypes.func.isRequired,
  bulkActionConsult: PropTypes.shape(BULK_ACTION_CONSULT).isRequired,
  handleCloseBulkActionConsult: PropTypes.func.isRequired,
};

export default BulkActionConsultFooter;
